import { render, staticRenderFns } from "./popup-bank.vue?vue&type=template&id=65eb3f38&scoped=true"
import script from "./popup-bank.vue?vue&type=script&lang=js"
export * from "./popup-bank.vue?vue&type=script&lang=js"
import style0 from "./popup-bank.vue?vue&type=style&index=0&id=65eb3f38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb3f38",
  null
  
)

export default component.exports